import React from 'react'
import GItData from '../Contents/GItData';
import Loader from '../Contents/Loader';

const References = () => {
  return (
    <div>
      <Loader/>
      <GItData/>
    </div>
  )
}

export default References;
